import { render, staticRenderFns } from "./DeclineButton.vue?vue&type=template&id=8e2235e4&scoped=true"
import script from "./DeclineButton.vue?vue&type=script&lang=js"
export * from "./DeclineButton.vue?vue&type=script&lang=js"
import style0 from "./DeclineButton.vue?vue&type=style&index=0&id=8e2235e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2235e4",
  null
  
)

export default component.exports